/* eslint-disable @typescript-eslint/no-shadow */
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import SelectInput from 'components/elements/Form/select/selectInput';
import LoadingSpinner from 'components/elements/Spinner/LoadingSpinner';
import MultiSelectInput from 'components/elements/Form/select/multiSelectInput';

type SelectEntityProps = {
  name: string;
  label: string;
  placeholder: string;
  queryname: string;
  query: any;
  uuid?: any;
  disabled?: any;
  loading?: boolean;
  wrapperClass?: string;
  Controller: any;
  control: any;
  errors: any;
  defaultValue?: any;
  multi?: boolean;
  sortBy?: string;
  expectedLabel?: string;
};
export default function SelectEntity({
  placeholder,
  queryname,
  name,
  query,
  label,
  uuid,
  Controller,
  disabled,
  control,
  errors,
  multi = false,
  defaultValue = '',
  sortBy = '',
  expectedLabel = ''
}: SelectEntityProps) {
  const { isLoading, isSuccess, data, refetch } = useQuery<any, Error>(
    queryname,
    uuid ? () => query(uuid) : query,
    {
      onError: (err: any) => {
        console.log(err.response?.data || err);
      }
    }
  );

  useEffect(() => {
    if (data) {
      refetch();
    }
  }, [data, refetch]);

  const formatedOptions = (value: any, label: string) => {
    return { value: value, label: label };
  };

  const renderOptions = () => {
    switch (expectedLabel) {
      case 'BadgeId/Description':
        if (data && Array.isArray(data)) {
          return Object.assign(data).map((item: { badgeId: number; description: string }) =>
            formatedOptions(item, `(${item.badgeId}) ${item.description}`)
          );
        }
        return formatedOptions(data, `(${data.badgeId}) ${data.description}`);
      case 'IntegrationPreference/Name':
        if (data && Array.isArray(data)) {
          return Object.assign(data).map((item: { uuid: string; name: string }) =>
            formatedOptions(item.uuid, `${item.name}`)
          );
        }
        return formatedOptions(data.uuid, `${data.name}`);
      case 'IntegrationKey/Name':
        if (data && Array.isArray(data)) {
          return Object.assign(data).map((item: { preferences: { uuid: string }; name: string }) =>
            formatedOptions(item.preferences.uuid, `${item.name}`)
          );
        }
        return formatedOptions(data.preferences.uuid, `${data.name}`);
      case 'Integration/Name':
        if (data && Array.isArray(data)) {
          return Object.assign(data).map((integration: { uuid: string; name: string }) => {
            let modifiedName = integration.name;
            if (modifiedName === 'bline') {
              modifiedName = 'B-Line';
            }
            return formatedOptions(integration.uuid, `${modifiedName}`);
          });
        }
        return formatedOptions(data.preferences.uuid, `${data.name}`);
      case 'FullName':
        if (data && Array.isArray(data)) {
          return Object.assign(data).map(
            (item: { uuid: string; firstName: string; lastName: string }) =>
              formatedOptions(item.uuid, `${item.firstName} ${item.lastName}`)
          );
        }
        return formatedOptions(data.uuid, `${data.firstName} ${data.lastName}`);
      default:
        // This block is for passing Uuid as value and name as label, it also sorts depending on scenarios like Resource type
        if (sortBy) {
          if (data && Array.isArray(data)) {
            const filteredTypeData = Object.assign(data).filter(
              (item: { type: string }) => item.type === sortBy
            );
            return Object.assign(filteredTypeData).map((item: { uuid: string; name: string }) =>
              formatedOptions(item.uuid, item.name)
            );
          }
        } else {
          if (data && Array.isArray(data)) {
            return Object.assign(data).map((item: { uuid: string; name: string }) =>
              formatedOptions(item.uuid, item.name)
            );
          }
          return [formatedOptions(data.uuid, data.name)];
        }
    }
  };

  return !isLoading && isSuccess ? (
    multi ? (
      <MultiSelectInput
        defaultValue={defaultValue}
        Controller={Controller}
        control={control}
        label={label}
        name={name}
        errors={errors}
        disabled={disabled}
        placeholder={placeholder}
        options={data && renderOptions()}
      />
    ) : (
      <SelectInput
        defaultValue={defaultValue}
        Controller={Controller}
        control={control}
        label={label}
        name={name}
        errors={errors}
        disabled={disabled}
        placeholder={placeholder}
        options={data && renderOptions()}
      />
    )
  ) : (
    <div>
      <LoadingSpinner />
    </div>
  );
}
